/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Home24HeroMesAmbienteHTML.css';
import RedButton from '@/components/atoms/RedButton';

function Home24HeroMesAmbienteHTML() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 413 && (
                  <img src="assets/mes-do-ambiente/home/img-312.svg" alt="" className="" />
                )}
                {width > 413 && width <= 599 && (
                  <img src="assets/mes-do-ambiente/home/img-414.svg" alt="" className="" />
                )}
                {width > 599 && width <= 799 && (
                  <img src="assets/mes-do-ambiente/home/img-800.svg" alt="" className="" />
                )}
                {width > 799 && (
                  <img src="assets/mes-do-ambiente/home/img-1280.svg" alt="" className="" />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            <div className="hero-selo">
              <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
            </div>
            <div className="hero-texts">
              <h1 className="hero-title">
                <b>Seu carro híbrido ou elétrico</b>
                <br /> está mais perto do que imagina.
              </h1>
              <h2 className="hero-sub-title">
                Simule com quem entende do assunto e <b>garanta condições exclusivas.</b>
              </h2>
            </div>
            <div className="hero-buttons">
              <RedButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=home:hero-banner&int_campaign=simular#/dados-pessoais "
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Simular
              </RedButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Home24HeroMesAmbienteHTML;
